import type { Application } from '../types/applications'
import type { MongoDBApplicationContext } from '../types/mongodb'

const applicationTagLabels = new Map([
	['applicationOwner', 'Application Owner'],
	['applicationOwnerEmail', 'Application Owner Email'],
	['wbsCode', 'WBS Code'],
	['applicationName', 'Application Name'],
	['projectId', 'GCP Project ID'],
	['costCenter', 'Cost Center'],
	['environment', 'Environment']
])

export const getMongoDBDisplayValue = (value: unknown): string => {
	if (value === undefined || value === null || value === '') return ''
	if (Array.isArray(value)) {
		return value.map(getMongoDBDisplayValue).filter(Boolean).join(', ')
	}
	if (typeof value === 'object') {
		const option = value as { label?: unknown; value?: unknown }
		if (option.label !== undefined && option.label !== '')
			return String(option.label)
		if (option.value !== undefined && option.value !== '')
			return String(option.value)
		return JSON.stringify(value) || ''
	}
	return String(value)
}

export const getMongoDBTagEntries = (tags: Record<string, unknown>) =>
	Object.entries(tags).flatMap(([key, value]) => {
		const label = applicationTagLabels.get(key)
		if (!label) return []
		const displayValue = getMongoDBDisplayValue(value)
		return displayValue !== '' ? [{ key, label, value: displayValue }] : []
	})

export const buildMongoDBApplicationDetails = (
	application: Application
): MongoDBApplicationContext => {
	const app = application as Application & { projectId?: string }
	const details = app.details

	return {
		applicationID: application.applicationID,
		applicationName: getMongoDBDisplayValue(details?.applicationName),
		environment: getMongoDBDisplayValue(
			details?.environment?.value ?? details?.environment
		),
		projectId: getMongoDBDisplayValue(
			app.projectId || details?.projectId
		).trim(),
		applicationOwner:
			getMongoDBDisplayValue(
				details?.applicationOwner ?? details?.applicationOwnerName
			) || 'N/A',
		applicationOwnerEmail:
			getMongoDBDisplayValue(details?.applicationOwnerEmail) || 'N/A',
		wbsCode: getMongoDBDisplayValue(details?.wbsCode).trim() || 'N/A',
		costCenter: getMongoDBDisplayValue(details?.costCenter).trim() || 'N/A'
	}
}
